// extracted by mini-css-extract-plugin
export default {"wrapper":"JustificationsList_wrapper__-IrWx","container":"JustificationsList_container__Hb3AF","title":"JustificationsList_title__rvMyv"};